package org.zq.pixelset

import androidx.compose.runtime.Composable
import org.zq.pixelset.ui.PixelSetApp

/** 全平台唯一 UI 入口：PixelSet 图片处理界面 */
@Composable
fun App() = PixelSetApp()
